var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPosColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 270v132c0 24.81-20.19 45-45 45h-195c-8.28 0-15-6.72-15-15v-192c0-8.28 6.72-15 15-15h195c24.81 0 45 20.19 45 45z",
    fill: "#ffe278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 270v132c0 24.81-20.19 45-45 45h-82.5v-222h82.5c24.81 0 45 20.19 45 45z",
    fill: "#ffb454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 270v34h-255v-64c0-8.28 6.72-15 15-15h195c24.81 0 45 20.19 45 45z",
    fill: "#ffb454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 270v34h-127.5v-79h82.5c24.81 0 45 20.19 45 45z",
    fill: "#ff8659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 46v420c0 24.81-20.19 45-45 45h-229c-24.81 0-45-20.19-45-45v-420c0-24.81 20.19-45 45-45h229c24.81 0 45 20.19 45 45z",
    fill: "#6b66d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 46v420c0 24.81-20.19 45-45 45h-114v-510h114c24.81 0 45 20.19 45 45z",
    fill: "#453d81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 80v128c0 8.28-6.72 15-15 15h-160c-8.28 0-15-6.72-15-15v-128c0-8.28 6.72-15 15-15h160c8.28 0 15 6.72 15 15z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 80v128c0 8.28-6.72 15-15 15h-80v-158h80c8.28 0 15 6.72 15 15z",
    fill: "#e2dff4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.71 285.07c-1.876-8.95-10.721-13.911-19.07-11.42-8.479 2.763-12.229 11.179-9.99 18.71 2.82 8.625 11.344 12.224 18.7 9.99 7.811-2.501 11.739-9.911 10.36-17.28z",
    fill: "#453d81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.29 290.93c1.68 8.097 9.332 13.337 17.64 11.78 8.117-1.691 13.333-9.343 11.78-17.64-1.89-9.017-10.863-13.917-19.061-11.42-7.698 2.457-11.757 9.81-10.359 17.28z",
    fill: "#2e2654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.71 349.07c-1.862-8.885-10.653-13.931-19.07-11.42-8.479 2.763-12.229 11.18-9.99 18.71 2.82 8.625 11.344 12.224 18.7 9.99 7.805-2.499 11.74-9.906 10.36-17.28z",
    fill: "#453d81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.71 349.07c-1.881-8.974-10.83-13.928-19.061-11.42-8.601 2.745-12.227 11.366-10 18.7 2.695 8.417 11.089 12.266 18.71 10 7.826-2.559 11.725-9.941 10.351-17.28z",
    fill: "#2e2654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.71 413.07c-1.862-8.885-10.653-13.931-19.07-11.42-8.602 2.803-12.201 11.273-9.99 18.71 2.819 8.623 11.362 12.218 18.7 9.99 7.728-2.474 11.754-9.833 10.36-17.28z",
    fill: "#afea93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.71 413.07c-1.886-8.999-10.847-13.922-19.061-11.42-8.286 2.644-12.291 11.004-10 18.71 2.81 8.596 11.241 12.211 18.71 9.99 7.788-2.546 11.735-9.885 10.351-17.28z",
    fill: "#ff8659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.6 297.51c-8.248 9.804-23.736 5.785-26.31-6.58-2.47-13.207 11.898-22.716 23.04-15.4 7.1 4.8 9.06 14.64 3.27 21.98z",
    fill: "#453d81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 303v-30.01c12.087-.044 19.811 14.111 11.6 24.52-3.18 3.78-7.43 5.5-11.6 5.49z",
    fill: "#2e2654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.6 361.51c-8.248 9.804-23.736 5.785-26.31-6.58-2.477-13.231 11.918-22.703 23.04-15.4 7.16 4.84 9.02 14.69 3.27 21.98z",
    fill: "#453d81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 367v-30.01c12.008-.043 19.857 14.051 11.6 24.52-3.18 3.78-7.43 5.5-11.6 5.49z",
    fill: "#2e2654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.93 430.71c-12.29 2.334-22.044-10.241-16.16-21.77 4.251-7.798 14.062-10.35 21.56-5.41 11 7.43 7.79 24.43-5.4 27.18z",
    fill: "#453d81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 430.99v-29.99c2.84 0 5.72.81 8.33 2.53 12.283 8.296 6.436 27.46-8.33 27.46z",
    fill: "#2e2654"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosColor);
export default __webpack_public_path__ + "static/media/pos-color.8d73bd121b8ee22c45ceefbb980e06ef.svg";
export { ForwardRef as ReactComponent };